import type { InterpretationStepModel } from '@/entities/optimization-statistic'
import type { CompetitiveDataPointModel } from '@/shared/generated'

export type CompetitiveDataPointExtended = {
	competitor_name?: string
	availability?: string
	promo_type_id?: string
	url?: string
	label: string
	color?: string
} & Omit<
	CompetitiveDataPointModel,
	'competitor_name' | 'availability' | 'promo_type_id' | 'url'
>
export type CompetitorDataGroup = {
	competitor_name?: string
	color?: string
	objects?: CompetitiveDataPointModel[]
}
export type ChartSerie = {
	color: string
	data: [number, number | null][]
	name: string
	pointInterval: number
	type: string
}

export enum InterpretationStages {
	SETUP = 'setup',
	PRICE_OPTIMIZATION = 'price_optimization',
	PRICE_ADJUSTMENT = 'price_adjustment',
	MANUALLY_CHANGED = 'manually_changed',
	FINAL_RESULT = 'final_result',
}

export type UiGroupType = {
	key: InterpretationStages
	title: string
	groupSteps: InterpretationStepModel[]
	finalPrice: number | null
}
